module.exports = __webpack_public_path__ + "img/zahnarztpraxiskoblenz_1.2d890074.jpg";